(ns web3.env
  (:require #?@(:cljs [[cljs.reader :as edn]]
                :clj  [[clojure.java.io :as io]
                       [aero.core :as aero]
                       [web3.build.versions :as versions]]))
  #?(:cljs
     (:require-macros [web3.env :as env])))

#?(:cljs
   (do
     (env/goog-define* release-flag :release-flag "none")
     (env/goog-define* devtools? :devtools? false)))

(def config
  "Map of environment variables, to be read at runtime."
  #?(:cljs (env/get-config-map)
     :clj  {}))

#?(:clj
   (do

     (defn- expand-set-keys [m]
       (reduce-kv (fn [m k v]
                    (if (set? k)
                      (reduce #(assoc %1 %2 v) m k)
                      (assoc m k v))) {} m))

     (defmethod aero/reader 'partner
       [{:keys [partner]} tag value]
       (let [value (expand-set-keys value)]
         (get value partner
              (get value :default))))

     (defn read-private-config
       [release-flag]
       (-> (io/resource "config/private-config.edn")
           (aero/read-config {:profile release-flag})
           (assoc :release-flag release-flag)))

     (def private-config
       "Environment variables only available at compile time"
       {})

     (defn read-config
       "Read environment variables config files, by release flag & current branch of repo."
       [release-flag partner-flag]
       (let [profile (some-> release-flag keyword)
             partner (some-> partner-flag keyword)]
         (->> ["config/config.edn"
               "config/.local-config.edn"
               (str "config/branch/" (versions/git-branch) ".edn")]
              (keep (fn [path]
                      (some-> (io/resource path)
                              (aero/read-config {:profile profile
                                                 :partner partner}))))
              (apply merge)
              (merge {:partner/id (name partner)
                      :release-flag release-flag
                      :release (versions/git-version)}))))

     (defmacro ^:private get-config-map
       "Returns config map at compile time"
       []
       config)

     (defmacro goog-define*
       "Like goog-define, but reads `k` from `env/config` at compile time "
       [name k default]
       `(~'goog-define ~name ~(get config k default)))))
